import { trackEvent } from './segment';

export const trackStyleQuizProductRate = ({
  productId,
  roomId,
  roomType,
  sqRating,
  studioId,
  userId
}) => {
  trackEvent({
    event: 'sq_product_rate',
    properties: {
      product_id: productId,
      room_id: roomId,
      room_type: roomType,
      sq_rating: sqRating,
      studio_id: studioId,
      user_id: userId
    }
  });
};

export const trackStyleQuizComplete = ({
  agreeToResult,
  studioId,
  style1,
  style2,
  style3,
  styleResult,
  userId
}) => {
  trackEvent({
    event: 'sq_complete',
    properties: {
      agree_to_result: agreeToResult,
      studio_id: studioId,
      style_1: style1,
      style_2: style2,
      style_3: style3,
      style_result: styleResult,
      user_id: userId
    }
  });
};

export const trackShowroomStyleQuizStarted = ({
  roomsChosen,
  studioId
}) => {
  trackEvent({
    event: 'showroom_sq_started',
    properties: {
      rooms_chosen: roomsChosen,
      studio_id: studioId
    }
  });
};

export const trackShowroomStyleQuizProductRate = ({
  product,
  rating,
  studioId
}) => {
  trackEvent({
    event: 'showroom_sq_product_rate',
    properties: {
      sq_product: product,
      rating,
      studio_id: studioId
    }
  });
};

export const trackShowroomStyleQuizComplete = ({
  agreeToResult,
  studioId,
  style1,
  style2,
  style3,
  styleResult,
  userId
}) => {
  trackEvent({
    event: 'showroom_sq_complete',
    properties: {
      agree_to_result: agreeToResult,
      studio_id: studioId,
      style_1: style1,
      style_2: style2,
      style_3: style3,
      style_result: styleResult,
      user_id: userId
    }
  });
};

export const trackSurveyResult = properties => {
  trackEvent({
    event: 'style_quiz_survey_result',
    properties: properties
  });
};
